"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryNavLink = exports.PrimaryNavItem = exports.PrimaryNav = exports.NumberBadgeWrapper = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ListGroup = require("@legacy-vfuk/core-list-group/dist/styles/ListGroup.style");

var _coreListItem = _interopRequireDefault(require("@legacy-vfuk/core-list-item"));

var _coreMixins = require("@legacy-vfuk/core-mixins");

var _coreInteraction = _interopRequireDefault(require("@legacy-vfuk/core-interaction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PrimaryNavLink = (0, _styledComponents["default"])(_coreInteraction["default"]).withConfig({
  displayName: "PrimaryNavstyle__PrimaryNavLink",
  componentId: "sc-17kgruw-0"
})(function (props) {
  return (0, _styledComponents.css)(["", ";position:relative;transition:", "s all ease;overflow:hidden;&::before{transition:", "s all ease;content:'';width:100%;height:", ";background:", ";display:block;position:absolute;top:calc(100% - ", ");left:0;transform:translateX(-100%);}", ""], (0, _coreMixins.advancedSpacing)('padding', [1, 0]), props.animationDuration / 1000, props.animationDuration / 1000, props.theme.border.width[2], props.theme.color.primary1["default"], props.theme.border.width[2], props.selected && (0, _styledComponents.css)(["&::before{transform:translateX(0);}font-weight:", ";"], props.theme.fontWeight[3]));
});
exports.PrimaryNavLink = PrimaryNavLink;
var PrimaryNavItem = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "PrimaryNavstyle__PrimaryNavItem",
  componentId: "sc-17kgruw-1"
})(function (props) {
  return (0, _styledComponents.css)(["", ";text-align:center;position:relative;&::after{display:block;content:'", "';font-weight:", ";color:transparent;overflow:hidden;visibility:hidden;height:0;@media speech{display:none;}}"], (0, _coreMixins.advancedSpacing)('margin', [0, 4]), props.text, props.theme.fontWeight[3]);
});
exports.PrimaryNavItem = PrimaryNavItem;

var PrimaryNav = _styledComponents["default"].div.withConfig({
  displayName: "PrimaryNavstyle__PrimaryNav",
  componentId: "sc-17kgruw-2"
})(function () {
  return (0, _styledComponents.css)(["", ";", "{display:flex;}"], _coreMixins.typography.heading(1, false), _ListGroup.ListGroup);
});

exports.PrimaryNav = PrimaryNav;

var NumberBadgeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PrimaryNavstyle__NumberBadgeWrapper",
  componentId: "sc-17kgruw-3"
})(function () {
  return (0, _styledComponents.css)(["position:absolute;left:100%;bottom:100%;transform:translate(0%,75%);"]);
});

exports.NumberBadgeWrapper = NumberBadgeWrapper;
//# sourceMappingURL=PrimaryNav.style.js.map